import React from 'react';
import { SkeletonSimple } from '~components/skeleton';

import './style.scss';

const WorkerDetailsSkeleton = () => {
  return (
    <div className="c-profile c-worker__slelenot-profile--page">


      <div className="worker__skelenon-profile">
        <div className="profile-card">
            <SkeletonSimple theme="primary" className="c-skeleton-simple__item c-profile-skeleton__image" />
            <SkeletonSimple theme="primary" className="c-skeleton-simple__item c-profile-skeleton__image_details" />
        </div>        
        <div className="bio">
            <SkeletonSimple theme="primary" className="c-skeleton-simple__item c-profile-skeleton__bio_line_one" />
            <SkeletonSimple theme="primary" className="c-skeleton-simple__item c-profile-skeleton__bio_line_two" />
            <SkeletonSimple theme="primary" className="c-skeleton-simple__item c-profile-skeleton__bio_line_two" />
            <SkeletonSimple theme="primary" className="c-skeleton-simple__item c-profile-skeleton__button" />
        </div>
      </div>

      <div className="c-profile__reviews reviews">
        <div className="title">
            <SkeletonSimple theme="primary" className="c-skeleton-simple__item c-profile-skeleton__firstName" />
        </div>        
        <div className="c-reviews-list">
          <SkeletonSimple theme="primary" className="c-skeleton-simple__item c-skeleton-simple__review" />
          <SkeletonSimple theme="primary" className="c-skeleton-simple__item c-skeleton-simple__review" />
        </div>
      </div>

      
        <div className="title">
            <SkeletonSimple theme="primary" className="c-skeleton-simple__item c-profile-skeleton__firstName" />
        </div>   
        <SkeletonSimple theme="primary" className="c-skeleton-simple__item c-profile-skeleton__map" />

      <div className="c-profile__about">
        <SkeletonSimple theme="primary" className="c-skeleton-simple__item c-profile-skeleton__about" />
      </div>

      {/* <div className="c-profile__header">
        <SkeletonSimple theme="primary" className="c-skeleton-simple__item c-profile-skeleton__firstName" />
        <SkeletonSimple theme="primary" className="c-skeleton-simple__item c-profile-skeleton__score" />
        <SkeletonSimple theme="primary" className="c-skeleton-simple__item c-profile-skeleton__price" />
        <div className="c-profile__top-buttons">
          <SkeletonSimple theme="primary" className="c-skeleton-simple__item c-profile-skeleton__button" />
          <SkeletonSimple theme="primary" className="c-skeleton-simple__item c-profile-skeleton__button" />
          <SkeletonSimple theme="primary" className="c-skeleton-simple__item c-profile-skeleton__button" />
        </div>
      </div> */}
      
    </div>
  );
};

export default WorkerDetailsSkeleton;
